import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About')
  },
  {
    path: '/docs',
    name: 'Docs',
    component: () => import(/* webpackChunkName: "about" */ '../views/Docs'),
    children: [
      {
        path: '/',
        component: () => import('../views/Docs/GettingStarted')
      },
      {
        path: 'button',
        component: () => import('../views/Docs/Button')
      },
      {
        path: 'tabs',
        component: () => import('../views/Docs/Tabs')
      },
      {
        path: 'range-slider',
        component: () => import('../views/Docs/RangeSlider')
      },
      {
        path: 'splash-message',
        component: () => import('../views/Docs/SplashMessage')
      },
      {
        path: 'vertical-panel',
        component: () => import('../views/Docs/VerticalPanel')
      },
      {
        path: 'toggle',
        component: () => import('../views/Docs/Toggle')
      },
      {
        path: 'textarea',
        component: () => import('../views/Docs/Textarea')
      },
      {
        path: 'checkbox',
        component: () => import('../views/Docs/Checkbox')
      },
      {
        path: 'input',
        component: () => import('../views/Docs/Input')
      },
      {
        path: 'select',
        component: () => import('../views/Docs/Select')
      },
      {
        path: 'radio',
        component: () => import('../views/Docs/Radio')
      },
      {
        path: 'rangeslider',
        component: () => import('../views/Docs/RangeSlider')
      },
      {
        path: 'memberstack',
        component: () => import('../views/Docs/MemberStack')
      },
      {
        path: 'dialog',
        component: () => import('../views/Docs/Dialog')
      },
      {
        path: 'multi-select',
        component: () => import('../views/Docs/MultiSelect')
      },
      {
        path: 'status-badge',
        component: () => import('../views/Docs/StatusBadge')
      },
      {
        path: '*',
        component: () => import('../views/ComingSoon'),
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
